import { Injectable } from '@angular/core';
import { Alert } from '../model/alert';
@Injectable()
export class ErrorService {

    alerts: Alert[];

    constructor() { 
        this.alerts = [];
    }

    handlerError(err){
        if(err instanceof String){
            this.alerts.push(new Alert('danger', 'An error has occured: ' + err));
        }else if(err.error){
            this.alerts.push(new Alert('danger', 'An error has occured: ' + err.error));
        }else if(err.message){
            this.alerts.push(new Alert('danger', 'An error has occured: ' + err.message));
        }else{
            this.alerts.push(new Alert('danger', 'An error has occured: ' + err));
        }
    }

    addInfo(info: string){
        this.alerts.push(new Alert('info', info));
    }

    addSuccess(info: string){
        this.alerts.push(new Alert('success', info));
    }

    close(alert: Alert) {
        this.alerts.splice(this.alerts.indexOf(alert), 1);
    }

    reset(){
        this.alerts = [];
    }
}